<template>
    <div class="flex flex-center-sp">
        <div class="about-body flex flex-col">
            <div class="margin-top-xxl flex flex-center-sp font-xxl font-bold">关于我们</div>
            <div class="margin-top-xxl about-word font-bold font-l">关于量子文档</div>
            <div class="margin-top-m  about-word margin-top-xl">物理学有个现象，叫量子纠缠，就是两个关联后的粒子，把他们分开后，无论他们相距多遥远，即使一个在太阳，一个在地球；其中一个粒子发生变化偏转，远在遥远地方的粒子，也会立即产生相应的动作。</div>
            <div class="margin-top-m  about-word">如果把分享者和接收者比作两个粒子，通过文档将两者建立联接，不管两者相隔多么遥远，接收者都会理解分享者的意图。</div>
            <div class="margin-top-m  about-word">所以，量子文档就这样应运而生了，量子文档将常用的文档从线下搬线上，赋予了更多的沟通属性，为用户之间架设起高效沟通的桥梁、是一款人人皆可用的极简文档分享工具。</div>
        </div>
    </div>

</template>

<script>
 export default {
    name:'About'
 }
    

</script>

<style scoped>
  .about-body {
    margin-top: 60px;
    width: 1000px;
    min-height: 500px;

  }
  .about-word {
    line-height: 30px;

  }
  


</style>


// WEBPACK FOOTER //
// src/views/About.vue